import { type FC, useEffect } from 'react';

import { cfetch } from '@confluence/network';

const parseFetchResponse = (response) =>
	response.json().then((json) => ({
		json,
		status: response.status,
		statusText: response.statusText,
		ok: response.ok,
	}));

type CcAnalyticsModuleProps = {
	cloudId: string;
	connectHost: any;
};

export const CcAnalyticsModule: FC<CcAnalyticsModuleProps> = ({ cloudId, connectHost }) => {
	useEffect(() => {
		const analyticsModule: any = {
			addonKey: 'com.addonengine.analytics',
			fetchStargate: (path, init) => {
				const resource = `/gateway/api/ex/confluence/${cloudId}/analytics${path}`;
				// eslint-disable-next-line check-credentials-option/has-credentials-option
				return cfetch(resource, init).then(parseFetchResponse);
			},
			getIconData: (resource) => {
				// eslint-disable-next-line check-credentials-option/has-credentials-option
				return cfetch(resource, {
					credentials: 'same-origin',
				}).then((response) =>
					response.blob().then(
						(blob) =>
							new Promise((resolve, reject) => {
								const reader = new window.FileReader();
								reader.onload = () => resolve(reader.result);
								reader.onerror = reject;
								reader.readAsDataURL(blob);
							}),
					),
				);
			},
			fetchQuery: (path, init) => {
				// eslint-disable-next-line check-credentials-option/has-credentials-option
				return cfetch(path, init).then(parseFetchResponse);
			},
		};
		analyticsModule.fetchStargate.returnsPromise = true;
		analyticsModule.fetchStargate.preserveNullProperties = true;
		analyticsModule.getIconData.returnsPromise = true;
		analyticsModule.fetchQuery.returnsPromise = true;
		analyticsModule.fetchQuery.preserveNullProperties = true;

		connectHost.defineModule('analytics', analyticsModule);
	}, [cloudId, connectHost]);

	return null;
};
